package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.base.BaseRequestModel
import com.example.mystybag.sharedmodels.AllCommands
import com.example.mystybag.sharedmodels.project.responseModels.merchant.BagProductSelection
import kotlinx.serialization.Serializable
import kotlinx.datetime.LocalDateTime

@Serializable
data class CreateBagRequestModel(
    val merchantLocationId: Long,
    /** Optional display title for the bag. */
    val title: String? = null,
    val activeFrom: LocalDateTime,
    val activeTo: LocalDateTime,
    /** Time from when order can be picked up (HH:mm). Optional. */
    val pickupTimeFrom: String? = null,
    /** Time until when order can be picked up (HH:mm). Optional. */
    val pickupTimeTo: String? = null,
    val bagsCount: Int,
    val priceNormal: Double,
    val priceWithDiscount: Double,
    val currency: String,
    /** Which products from the location are included in this bag. */
    val productSelection: BagProductSelection = BagProductSelection(),
    val containsProductsForPersonsOver18: Boolean = false
) : BaseRequestModel(api = AllCommands.CREATE_BAG)

@Serializable
data class BagAllergenItem(
    val nomenclatureId: Long, // id from nomenclature_ingredients or nomenclature_allergens
    val name: String? = null
)
